var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { wrapDispatch } from "../../Multireducer";

import { NeedAuthorization } from "../../Auth";
import { Translate, I18NLink } from "../../I18N";
import { Icon } from "../../UI";

import { ShareButton } from "../../Permissions/components/ShareButton";
import * as actions from "../actions/actions";

class MetadataFormButtons extends Component {
  render() {
    const {
      entityBeingEdited,
      exclusivelyViewButton,
      formName,
      hideDelete,
      uploadFileprogress,
      formState
    } = this.props;
    const data = this.props.data.toJS();
    const shouldDisable = formState.$form.pending || uploadFileprogress !== undefined;

    const ViewButton = /*#__PURE__*/
    _jsx(I18NLink, {
      to: `entity/${data.sharedId}`,
      className: "edit-metadata btn btn-default",
      tabIndex: "0" }, void 0, /*#__PURE__*/

    _jsx(Icon, { icon: "file" }), /*#__PURE__*/
    _jsx("span", { className: "btn-label" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "View")
    )
    );


    if (exclusivelyViewButton) {
      return /*#__PURE__*/_jsx("span", {}, void 0, ViewButton);
    }

    return /*#__PURE__*/(
      React.createElement(React.Fragment, null, /*#__PURE__*/
      _jsx("div", { className: "btn-cluster" }, void 0,
      this.props.includeViewButton && data.sharedId && ViewButton, /*#__PURE__*/
      _jsx(NeedAuthorization, { roles: ['admin', 'editor'], orWriteAccessTo: [data] }, void 0,
      !entityBeingEdited && /*#__PURE__*/
      _jsx("button", {
        type: "button",
        onClick: () => {
          this.props.loadInReduxForm(
            this.props.formStatePath,
            data,
            this.props.templates.toJS()
          );
          this.props.clearMetadataSelections();
        },
        className: "edit-metadata btn btn-default" }, void 0, /*#__PURE__*/

      _jsx(Icon, { icon: "pencil-alt" }), /*#__PURE__*/
      _jsx("span", { className: "btn-label" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Edit")
      )
      )

      ), /*#__PURE__*/
      _jsx(NeedAuthorization, { roles: ['admin', 'editor'], orWriteAccessTo: [data] }, void 0,
      !entityBeingEdited && !hideDelete && data && data.sharedId && /*#__PURE__*/
      _jsx(ShareButton, { sharedIds: [data.sharedId], storeKey: this.props.storeKey })

      ),
      entityBeingEdited && /*#__PURE__*/
      _jsx("button", {
        type: "button",
        className: "btn btn-default copy-from-btn",
        onClick: this.props.copyFrom,
        disabled: shouldDisable }, void 0, /*#__PURE__*/

      _jsx(Icon, { icon: "copy-from", transform: "left-0.07 up-0.06" }), /*#__PURE__*/
      _jsx("span", { className: "btn-label" }, void 0,
      ' ', /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Copy From")
      )
      )

      ), /*#__PURE__*/
      _jsx("div", { className: "btn-cluster content-right" }, void 0,
      entityBeingEdited && /*#__PURE__*/
      React.createElement(React.Fragment, null, /*#__PURE__*/
      _jsx("button", {
        type: "button",
        disabled: shouldDisable,
        onClick: () => this.props.resetForm(this.props.formStatePath),
        className: "cancel-edit-metadata btn btn-default btn-extra-padding" }, void 0, /*#__PURE__*/

      _jsx("span", { className: "btn-label" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Cancel")
      )
      ), /*#__PURE__*/
      _jsx("button", {
        type: "submit",
        form: formName,
        className: "btn btn-success btn-extra-padding",
        disabled: shouldDisable }, void 0,

      uploadFileprogress ? /*#__PURE__*/_jsx(Icon, { icon: "spinner", spin: true }) : null, /*#__PURE__*/
      _jsx("span", { className: "btn-label" }, void 0,
      uploadFileprogress ? /*#__PURE__*/
      _jsx("span", {}, void 0, `${uploadFileprogress}%`) : /*#__PURE__*/

      _jsx(Translate, {}, void 0, "Save")

      )
      )
      ), /*#__PURE__*/

      _jsx(NeedAuthorization, { roles: ['admin', 'editor'], orWriteAccessTo: [data] }, void 0,
      !entityBeingEdited && !hideDelete && /*#__PURE__*/
      _jsx("button", {
        className: "delete-metadata btn btn-danger",
        type: "button",
        onClick: this.props.delete }, void 0, /*#__PURE__*/

      _jsx(Icon, { icon: "trash-alt" }), /*#__PURE__*/
      _jsx("span", { className: "btn-label" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Delete")
      )
      )

      )
      )
      ));

  }
}

MetadataFormButtons.defaultProps = {
  entityBeingEdited: false,
  includeViewButton: true,
  hideDelete: false,
  formName: 'metadataForm',
  delete: () => {},
  copyFrom: () => {},
  storeKey: undefined,
  uploadFileprogress: undefined
};




















const mapStateToProps = (state, ownProps) => {
  const { sharedId } = ownProps.data.toJS();
  return {
    templates: state.templates,
    uploadFileprogress: sharedId ?
    state.attachments.progress.get(sharedId) :
    state.attachments.progress.get('NEW_ENTITY')
  };
};

function mapDispatchToProps(dispatch, props) {
  return bindActionCreators(
    {
      loadInReduxForm: actions.loadInReduxForm,
      resetForm: actions.resetReduxForm,
      clearMetadataSelections: actions.clearMetadataSelections
    },
    wrapDispatch(dispatch, props.storeKey)
  );
}

export { MetadataFormButtons };
export default connect(mapStateToProps, mapDispatchToProps)(MetadataFormButtons);